import { render } from "./HomePath.vue?vue&type=template&id=4e0168aa"
import script from "./HomePath.vue?vue&type=script&lang=js"
export * from "./HomePath.vue?vue&type=script&lang=js"

import exportComponent from "/home/magpie/dnd/client/gamemasterai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__